// convert hex colors to rgb
const convertToRGB = (hex: string) => {
  const hexColor = hex.replace("#", "");
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);
  return `${r},${g},${b}`;
};

const convertToHex = (rgb: string) => {
  const [r, g, b] = rgb.split(",").map(Number); // Convert to numbers
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export { convertToRGB, convertToHex };